import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { LoginPage } from "@/features/auth/LoginPage";
import { mayFollowReturnLink, safeFrom } from "@/features/auth/safeFrom";
import { sessionActions } from "@/features/auth/session";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    from: z.string().optional(),
    ended: z.coerce.number().optional().catch(undefined),
  }),
  beforeLoad: async ({ search }) => {
    const s = await sessionActions.whenSettled({ resume: false });
    if (s.status === "authenticated")
      // Same rule as signing in: another user's ended-session link isn't followed.
      throw redirect({
        href:
          (mayFollowReturnLink(s.userId, { ended: !!search.ended }) ? safeFrom(search.from) : undefined) ??
          "/app",
        replace: true,
      });
  },
  component: LoginPage,
});
